module.exports = __webpack_public_path__ + "static/media/tuat.a4566233.svg";